export default {
  /*按钮*/
  bt: {
    search: '查询',
    find: '搜索',
    reset: '重置',
    add: '新增',
    save: '保存',
    saveAndNext: '保存并到下一条',
    noAndNext: '暂不评估，下一条',
    operator: '操作',
    update: '修改',
    delete: '删除',
    down: '下载',
    export: '导出',
    upload: '上传',
    hideOrNo: '列表显示隐藏',
    definite: '确定',
    cancel: '取消',
    addOne: '增加一条',
    edit: '编辑',
    allSelect: '全选',
    downModel: '下载模板',
    uploadNow: '立即上传',
    allOpen: '全部展开',
    allClose: '全部收起'
  },
  /*公用字段或工具函数字段*/
  common: {
    companyId: '公司id',
    bizCode: '业务',
    bizCodeName: '所属业务',
    placeholderBizCodeName: '请选择所属业务',
    locale: '语言',
    placeholderLanguage: '请选择语言',
    enable: '状态',
    startTime: '开始时间',
    placeholderStartTime: '选择开始时间',
    endTime: '结束时间',
    placeholderEndTime: '选择结束时间',
    createDate: '创建时间',
    updateDate: '更新时间',
    replyTime: '接通时间',
    enableNo: '禁用',
    enableYes: '启用',
    no: '否',
    yes: '是',
    online: '在线',
    business: '忙碌',
    offline: '离线',
    tip: '提示',
    mobile: 'M端',
    pc: 'PC端',
    app: 'APP端',
    cancelDel: '已取消删除',
    delForever: '此操作将永久删除该数据, 是否继续?',
    delSuc: '删除成功!',
    delFail: '删除失败，请稍后再试',
    addSuc: '添加成功!',
    addFail: '添加失败，请稍后再试',
    updateSuc: '更新成功!',
    updateFail: '更新失败，请稍后再试',
    notExceed: '添加不能超过3条',
    notNull: '输入内容不能为空，请重新输入!',
    send: '发送',
    name: '姓名',
    placeholderName: '请输入姓名',
    phone: '手机号码',
    email: '邮箱',
    placeholderEmail: '请输入邮箱',
    tel: '固话',
    telephone: '电话',
    placeholderPhone: '请输入电话',
    qq: 'QQ',
    placeholderQQ: '请输入QQ号码',
    weChat: '微信',
    placeholderWeChat: '请输入微信号',
    zalo: 'Zalo',
    facebook: 'Facebook',
    whatsApp: 'Whatsapp',
    remark: '备注',
    placeholderRemark: '请输入备注信息',
    title: '标题',
    file: '文件',
    fileTitle: '文件标题',
    fileName: '文件名称',
    uploadTime: '上传时间',
    hreAddress: '链接',
    pic: '图片',
    picTitle: '图片标题',
    visitorsType: '访客类型',
    placeholderVisitorsType: '请选择访客类型',
    businessType: '业务类型',
    placeholderBusinessType: '请选择业务类型',
    traveler: '游客',
    demo: '模拟',
    inactivated: '未激活',
    activated: '已激活',
    accountNum: '交易账号',
    placeholderAccountNum: '请输入交易账号',
    visitorsName: '访客名称',
    placeholderVisitorsName: '请输入访客名称',
    visitorsID: '访客ID',
    placeholderVisitorsID: '请输入访客ID',
    visitorsIp: '访客IP',
    placeholderVisitorsIp: '请输入访客IP',
    visitorsAddress: '访客地区',
    placeholderProvince: '请选择省份',
    placeholderCity: '请选择城市',
    visitorsSource: '访客来源',
    visitorsNum: '访问次数',
    massageTime: '留言时间',
    status: '状态',
    placeholderStatus: '请选择状态',
    replayTime: '回复时间',
    massageType: '留言类型',
    replayOperator: '回复人员',
    placeholderReplayOperator: '请选择回复人员',
    detail: '详情',
    userTypeName: '客户类型',
    visitorsWay: '访问方式',
    sort: '排序',
    content: '内容',
    clientDetail: '浏览器',
    address: '地理位置',
    lastAccessAddress: '最近访问页',
    userID: '客户ID',
    sex: '性别',
    boy: '男',
    girl: '女',
    placeholderSex: '请选择性别',
    tradePlatform: '交易平台',
    accountStatus: '账号状态',
    activeTime: '激活时间',
    lastMoneyTime: '最近一次入金时间',
    tradeHandNum: '累计交易手数',
    lastTradeTime: '最近一次交易时间',
    accountChannel: '开户渠道',
    activityNum: '参与活动数',
    ccFollow: 'CC跟进人',
    placeholderCC: '请输入CC跟进人',
    csFollow: 'CS跟进人',
    placeholderCS: '请输入CS跟进人',
    rmFollow: 'RM跟进人',
    placeholderRM: '请输入RM跟进人',
    chatTheme: '对话主题',
    placeholderChatTheme: '请选择对话主题',
    chatLevel: '会话级别',
    placeholderChatLevel: '请选择会话级别',
    placeholderKeywords: '请输入关键词',
    userSource: '访客渠道',
    serviceName: '客服姓名',
    placeholderServiceName: '请选择客服姓名',
    sessionTime: '对话时长',
    userIp: '访问IP',
    serviceQuality: '服务质量',
    placeholderServiceQuality: '请选择服务质量',
    chatRecordKey: '聊天记录关键字',
    placeholderChatRecordKey: '请输入聊天记录关键字',
  },
  /**
   * 文件上传
   */
  upload: {
    numPrefix: '只能选择',
    numMid: '个文件，当前共选择了',
    numSuffix: '个',
    uploadTitle: '文件上传',
    success: '文件上传成功',
    fail: '文件上传失败',
    pleaseUpload: '请上传文件',
    excelTipOne: '只能上传后缀是.xlsx的文件',
    excelTipTwo: '文件大小不得超过10M',
    uploadTipPrefix: '将文件拖到此处，或',
    uploadTipSuffix: '点击上传',
    uploadNumTip: '只能上传xlsx文件，且不超过10M',
    downExample: '下载模版',
    uploadButton: '立刻上传',
    uploadPicTip: '只能上传jpg/png文件，且不超过500kb',
    uploadImgTip: '只支持jpg、png、gif格式的图片！',
    uploadPicFail: '图片上传失败，请稍后再试！',
    uploadingImg: '图片上传中'
  },
  /**
   * 机器人配置页面
   */
  robotList: {
    name: '名称',
    welcome: '机器人欢迎语',
    remark: '描述'
  },
  /**
   * 知识分类页面
   */
  knowledgeCategoryList: {
    name: '分类名称',
    remark: '分类描述',
    createDateRange: '创建时间'
  },
  /**
   * 知识库页面
   */
  knowledgeList: {
    name: '知识名称',
    title: '知识标题',
    keywords: '关键词',
    keywordsPlaceholder: '多个关键字用英文逗号分隔',
    categoryId: '知识分类',
    recommend: '是否推荐',
    content: '问题答案',
    createDateRange: '创建时间',
    export: '导出知识',
    exportName: '知识库导出',
    upload: '批量导入',
    recommendNo: '未推荐',
    recommendYes: '推荐',
    operatorName: '创建人',
    open: '开户',
    deposit: '存款',
    withdraw: '取款',
    transaction: '交易',
    activities: '新客活动',
    category: '分类',
    weight: '权重',
    searchNum: '搜索次数',
    usefulNum: '有用次数',
    uselessNum: '无用次数'
  },
  /**
   * 场景配置
   */
  sceneList: {
    name: '场景标题',
    namePlaceholder: '请输入场景标题',
    welcomeMessage: '进线消息',
    directManual: '是否直达人工',
    createDateRange: '创建时间',
    addTitle: '新建场景',
    formBizCode: '所属业务',
    formBizCodePlaceholder: '请选择所属业务',
    recommendKnowledge: '推荐知识',
    selectKnowledge: '选择知识',
    localePlaceholder: '请选择语言',
    manualService: '人工客服',
    directManualService: '直达人工客服',
    knowledgeTitle: '知识标题',
    knowledgeTitlePlaceholder: '请输入知识标题',
    knowledgeType: '知识类型',
    knowledgeTypePlaceholder: '请选择知识类型',
    startDate: '开始时间',
    startDatePlaceholder: '选择开始时间',
    endDate: '结束时间',
    endDatePlaceholder: '选择结束时间',
    knowledgeId: '知识ID',
    knowledgeName: '知识名称',
    formKnowledgeTitleValid: '请输入场景标题',
    formKnowledgeBizCodeValid: '请选择所属业务',
    formKnowledgeLocaleValid: '请选择语言'
  },
  /**
   * 个人欢迎语
   */
  privateWelcome: {
    message: '内容'
  },
  /**
   * 自动回复设置
   */
  privateAutoAnswer: {
    message: '内容'
  },
  /**
   * 首页
   * */
  imIndex: {
    chatStatus: '请选择客服状态',
    chatDisconnect: '聊天链接已断开，请重连',
    refresh: '重新连接',
    chatTip: '客服信息提示',
    chatTipCon: '您有新的消息，请注意查收',
    notWebSocket: '您的浏览器不支持socket',
    onopen: '建立连接...',
    onclose: '断开连接...',
    onmessage: '连接成功'
  },
  /**
   * 内部协同
   */
  chatAllSystem: {
    inputChatName: '请输入客服昵称',
    cueHim: '@他',
    personToPerson: '私聊'
  },
  /**
   * 对话级别
   */
  chatLevel: {
    createLevel: '新建会话级别',
    updateLevel: '修改会话级别',
    chatLevel: '会话级别',
    level: '级别'
  },
  /**
   * 对话主题
   */
  chatTheme: {
    createTheme: '新建主题',
    updateTheme: '修改主题',
    theme: '主题'
  },
  /**
   * 桌面对话窗口设置
   */
  desktopChat: {
    clickEditLogo: '点击编辑LOGO',
    editLogo: '编辑LOGO',
    clickEditBgColor: '点击编辑背景颜色',
    editBgColor: '编辑背景颜色',
    background: '背景颜色',
    clickAd1: '点击编辑广告一',
    clickAd2: '点击编辑广告二',
    editAd: '编辑广告',
    isVerify: '是否开户验证码',
    logoHrefUrl: '跳转链接',
    inputLogoHrefUrl: '请输入跳转链接',
    adPic: '广告图片'
  },
  /**
   * 访客IP限制设置
   */
  limitVisitorsIP: {
    addLimit: '新增访客限制',
    updateLimit: '修改访客限制',
    limitType: '限制类型',
    limitTypeCon: '限制类型内容',
    placeholderLimitType: '请输入IP或账号',
    limitReason: '阻止原因',
    ip: 'IP',
    account: '账号'
  },
  /**
   * 留言设置
   */
  message: {
    title: '客服离线客户信息留言收集',
    titleCon: '客服离线留言指的是客户进线的时候当前所有客服都在离线状态，客户留言。',
    form: '表单项',
    isRequired: '是否必填',
    adaptationBizCode: '适配业务',
    EffectPreview: '效果预览',
    message: '留言',
    editMessageGuide: '编辑留言引导语',
    clickEditMessageGuide: '编辑留言引导语',
    messageGuide: '留言引导语',
    messageSuc: '留言成功页内容'
  },
  /**
   * 常用文件管理/链接管理/图片管理
   */
  oftenFile: {
    inputTitleKey: '请输入标题关键词',
    uploadFile: '上传文件',
    updateFile: '修改文件',
    addOftenHref: '新建常用链接',
    updateOftenHref: '修改常用链接',
    hrefUrl: '链接地址',
    titleOrHref: '标题或链接地址不能为空',
    pic: '图片',
    uploadPic: '上传图片',
    updatePic: '上传图片'
  },
  /**
   * 访问分配设置
   */
  visitorsDistribution: {
    prioritySet: '优先级设置',
    priorityCon: '内优先分配给上次客服<em>（注：默认为5分钟）</em>',
    priorityExplain: '如果访客不是第一次进线，则访客在规定时间内优先分配给上次分配的客服，如果上次客服不在线，则按普通客户分配；',
    allocationSet: '分配方式设置',
    allocationType1: '销售型——系统会将访客轮流分配给每个客服人员，如果当前客服接待人数上限已满，则跳过',
    allocationType0: '客服型——系统分配给工作负载小的客服（工作负载等于当前接待的访客除以接待上线数），如果负载相同，则分配给最久未接待新访客的客服',
    allocationType2: '优先分配对话最少的客服',
    editChatRelated: '客服关联编辑',
    chatId: '客服ID',
    id: 'ID',
    userName: '登录名称',
    displayName: '昵称',
    rolesStr: '角色',
    companyName: '所属公司',
    relatedBusiness: '关联业务',
    upperLimit: '接待上限',
    minute: '分',
    second: '秒',
    hour: '时'
  },
  /**
   * 欢迎语
   */
  welcome: {
    title: '欢迎语',
    addWelcome: '新增欢迎语',
    updateWelcome: '新增欢迎语'
  },
  /**
   * 留言管理
   */
  messageManagement: {
    messageDetailTitle: '留言详情',
    messageCon: '留言内容',
    replyCon: '回复内容',
    placeholderReply: '请输入回复内容',
    replyNo: '未回复',
    replyYes: '已回复',
    all: '全部',
    cityArea: '市辖区',
    saveMessageSuc: '保存留言成功',
    saveMessageFail: '保存留言失败，请稍后再试！',
    isNull: '回复内容不能为空！',
    messageExport: '留言导出'
  },
  /**
   * 聊天框
   */
  chatRoom: {
    offline: '客户已离线',
    artificialChat: '接待该用户',
    artificialFail: '接待失败，请稍微再试！',
    notArtificial: '当前没有聊天对象，不能接待用户，请先选择聊天对象！',
    fileType: '文件格式不对',
    picType: '图片不能超过5M',
    sendNotNull: '发送内容不能为空',
    notSend: '当前没有聊天对象，不能发送信息，请先选择聊天对象！',
    noMore: '没有更多数据了'
  },
  /**
   * 对话管理
   */
  commonChat: {
    waitAccept: '待接入',
    waitEvaluated: '待评估',
    acceptSession: '接受对话',
    limitVisitorsIP: '访客IP限制设置',
    chatMonitor: '监控客服',
    enableAutoReply:"启动自动回复",
    closeAutoReply:"关闭自动回复",
    customerInfo: '客户信息',
    historyChat: '历史会话',
    sourceHref: '点击查看来源链接',
    chatList: '会话列表',
    chatEnd: '结束对话',
    chatSend: '传送对话',
    waitAcceptInfo: '待接入信息',
    accept: '接入',
    acceptAll: '全部接入',
    send: '传送',
    waitEvaluatedInfo: '待评估信息',
    goEvaluated1: '与',
    goEvaluated2: '进行评估',
    chatRecord1: '与',
    chatRecord2: '对话记录',
    chatStart: '对话开始',
    chatEnds: '对话结束',
    customerOff: '客户离线',
    chatClose: '客服主动关闭会话',
    evaluatedInfo: '评估信息',
    isNotNull: '对话主题、对话级别不能为空！',
    acceptSessionInfo: '接受对话信息',
    reception: '接受',
    refusal: '拒绝',
    chatSendInfo: '传送对话信息',
    sender: '传送人',
    receiver: '接收人',
    chatID: '会话ID',
    sendReason: '传送理由',
    placeholderSendReason: '请输入传送理由',
    chatInfo: '会话详情',
    checkChatMonitor: '选择监控客服',
    noData: '暂无数据',
    commonWords: '公共常用语',
    personalWords: '个人常用语',
    commonHref: '常用链接',
    commonImg: '常用图片',
    commonFile: '常用文件',
    endReason: '结束原因',
    checkChat: '请选择会话客户！',
    notEdit: '目前客户信息为不可编辑状态，请先变为可编辑状态！',
    updateSuc: '修改客户信息成功!',
    updateFail: '修改客户信息失败，请稍后再试',
    notCopy: '该浏览器不支持自动复制',
    length: '搜索关键字字数必须大于等于2！',
    evaluatedSuc: '评估成功！',
    acceptSuc: '接入成功!',
    acceptFail: '接入失败，请稍后再试',
    sendSingle: '只能传送单条会话',
    hasSend: '此条会话已被传送，请传送其他会话',
    checkSend: '请先选择需要传送的会话',
    notSender: '未选择传送人，请先选择传送人！',
    sendSuc: '传送成功！',
    sendFail: '传送失败，请稍后再试',
    isAccept: '是否接受会话?',
    receptionSuc: '接受成功！',
    receptionFail: '接受失败，请稍后再试',
    receptionCancel: '已取消接受会话',
    isRefusal: '是否拒绝会话?',
    refusalSuc: '拒绝成功',
    refusalFail: '拒绝失败，请稍后再试',
    refusalCancel: '已取消拒绝会话',
    chatEndsFail: '对话结束失败，请稍后再试',
    checkChatEnds: '请先勾选需要结束的会话',
    startMonitor: '开始监控',
    monitorFail1: '监控',
    monitorFail2: '失败，请稍后再试'
  },
  /**
   * 对话记录
   */
  chatRecord: {
    visitorsAccount: '访客账号',
    placeholderAccount: '请输入账号',
    visitorsType: '访客方式',
    placeholderVisitorsType: '请选择访客方式',
    serviceQuality0: '未评论',
    serviceQuality1: '一星',
    serviceQuality2: '二星',
    serviceQuality3: '三星',
    serviceQuality4: '四星',
    serviceQuality5: '五星',
    saveSuc: '评估成功！本对话已是本页最后一条，请先到列表翻页进入下一页',
    noNext: '本对话已是本页最后一条，请先到列表翻页进入下一页'
  },
  /**
   * 常用语
   */
  commonWords: {
    addCommonWordsList: '新建常用语目录',
    addCommonWords: '新建常用语',
    importAll: '批量导入',
    commonWordsList: '常用语目录',
    placeholderCommonWordsList: '常用语目录',
    contentTxt: '内容',
    updateCommonWords: '修改常用语',
    updateCommonWordsList: '修改常用语',
    checkDel: '请先选择需要删除的选项',
    notCommonWordsList: '常用语目录不能为空，请输入常用语目录',
    notCommonWordsList1: '常用语目录不能为空，请先新建常用语目录',
    notTitle: '标题不能为空，请输入标题',
    exceedFile1: '只能选择 ',
    exceedFile2: ' 个文件，当前共选择了',
    exceedFile3: ' 个'

  }
}
